import { Button } from '@mui/material'
import type { ButtonProps } from '@mui/material'

/** Toolbar Add-style action for Setup pages (small contained, secondary / brand accent — matches domain & API Add). */
const SetupToolbarButton = ({
  size = 'small',
  variant = 'contained',
  color = 'secondary',
  ...props
}: ButtonProps) => {
  return (
    <Button
      size={size}
      variant={variant}
      color={color}
      {...props}
    />
  )
}

export default SetupToolbarButton
